module.exports = __webpack_public_path__ + "static/media/bharat.15b0169e.webp";